import type { FaireBrandEntity } from "../../entity_types/brand";

export const casa_bosques: FaireBrandEntity = {
  token: "casa-bosques",
  type: "brand",
  name: "Casa Bosques",
  location: "NYC, New York",
  minimumOrderDollars: 150,
  rating: 5,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
